// extracted by mini-css-extract-plugin
export default {"container":"report_container__Kv+yR","errorContainer":"report_errorContainer__RHd-V","errorText":"report_errorText__ku-3z","summary":"report_summary__PWL5L"};